import { Component, input } from '@angular/core';
import { IconComponent } from '../icon/icon.component';
import { AlertTypeEnum } from './alert.types';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  imports: [IconComponent],
})
export class AlertComponent {
  protected AlertTypeEnum = AlertTypeEnum;

  public message = input.required<string>();
  public type = input<AlertTypeEnum>(AlertTypeEnum.ERROR);
}
